import React from 'react';
import { Route } from 'react-router-dom';
import List from './containers/List';
import { routes } from 'shared/constants/routes';

export default () => (
  <Route path={routes.planning.default.path} key="planning-default" component={List} exact />
);
